// Deterministic placement on the infinite board.
// New notes land on a golden-angle sunflower spiral around the
// masthead at the origin — organically clustered, never badly
// overlapping, and identical for every visitor.

const GOLDEN_ANGLE = 2.399963229728653;

/** Kept clear for the masthead sheet at the origin. */
const INNER_RADIUS = 330;
const SPREAD = 165;

export function spiralPosition(index: number): { x: number; y: number } {
  const r = INNER_RADIUS + SPREAD * Math.sqrt(index);
  const a = (index + 1) * GOLDEN_ANGLE;
  return { x: Math.round(Math.cos(a) * r), y: Math.round(Math.sin(a) * r * 0.85) };
}

/** Stable per-note hash for cosmetic variation (lift shadow etc.). */
export function noteHash(id: string): number {
  let h = 0;
  for (const c of id) h = (h * 33 + c.charCodeAt(0)) >>> 0;
  return h;
}
